import { ErrorType } from "@wix/ambassador-forms-v1-validation-result/types";
import { ErrorType as ErrorType2, ValidationMode } from "@wix/ambassador-forms-v1-validation-result/types";
import { isSchemaValidationProperty } from "./schema-validation-properties.js";
const ajvErrorKeywordMap = {
  type: ErrorType.TYPE_ERROR,
  required: ErrorType.REQUIRED_VALUE_ERROR,
  maxLength: ErrorType.MAX_LENGTH_ERROR,
  minLength: ErrorType.MIN_LENGTH_ERROR,
  pattern: ErrorType.PATTERN_ERROR,
  format: ErrorType.FORMAT_ERROR,
  allowedCountryCodes: ErrorType.NOT_ALLOWED_VALUE_ERROR,
  countryCode: ErrorType.INVALID_PHONE_COUNTRY_CODE_ERROR,
  maximum: ErrorType.MAX_VALUE_ERROR,
  minimum: ErrorType.MIN_VALUE_ERROR,
  multipleOf: ErrorType.MULTIPLE_OF_VALUE_ERROR,
  additionalProperties: ErrorType.UNKNOWN_VALUE_ERROR,
  minItems: ErrorType.MIN_ITEMS_ERROR,
  maxItems: ErrorType.MAX_ITEMS_ERROR,
  enum: ErrorType.NOT_ALLOWED_VALUE_ERROR,
  formatMinimum: ErrorType.MIN_VALUE_ERROR,
  formatMaximum: ErrorType.MAX_VALUE_ERROR
};
function getErrorFieldId(errorType, ajvError, fieldIdMask) {
  switch (errorType) {
    case ErrorType.REQUIRED_VALUE_ERROR:
      return combineErrorPaths(
        ajvError.instancePath,
        ajvError.params.missingProperty
      );
    case ErrorType.UNKNOWN_VALUE_ERROR:
      return combineErrorPaths(
        ajvError.instancePath,
        ajvError.params.additionalProperty
      );
    default:
      return fieldIdMask || ajvError.instancePath.substring(1);
  }
}
function combineErrorPaths(rootPath, property) {
  return [rootPath, property].join("/").substring(1);
}
function makeValidationError(ajvError, fieldIdMask) {
  const [errorDetails] = ajvError.params?.errors || [ajvError];
  const isCustomError = ajvError.keyword === "errorMessage" && isSchemaValidationProperty(errorDetails.keyword);
  const errorType = ajvErrorKeywordMap[errorDetails.keyword] || ErrorType.UNKNOWN_ERROR;
  const fieldId = getErrorFieldId(errorType, errorDetails, fieldIdMask);
  return {
    errorPath: fieldId,
    errorType,
    errorMessage: ajvError.message || "",
    params: errorDetails.params,
    ...isCustomError && { useCustomErrorMessage: true }
  };
}
function makeValidationErrors(ajvErrors, fieldIdMask) {
  if (!ajvErrors) {
    return [];
  }
  return ajvErrors.map(
    (ajvError) => makeValidationError(ajvError, fieldIdMask)
  );
}
function groupErrorsByTarget(errors) {
  return errors.reduce((byTarget, error) => {
    const [target, ...rest] = error.errorPath.split("/");
    if (!byTarget[target]) {
      byTarget[target] = [];
    }
    byTarget[target].push({ ...error, errorPath: rest.join("/") });
    return byTarget;
  }, {});
}
export {
  ErrorType2 as ErrorTypes,
  ValidationMode,
  groupErrorsByTarget,
  makeValidationErrors
};
//# sourceMappingURL=errors.js.map
